import { render } from "./ThePortfolioSection.vue?vue&type=template&id=848ac714"
import script from "./ThePortfolioSection.vue?vue&type=script&lang=js"
export * from "./ThePortfolioSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__